import Flower from './Flower/Flower';
import Gallery from './Gallery/Gallery';
import Tutor from './Tutor/Tutor';
import UserForm from './UserForm/UserForm';
import Ping from './Ping/Ping';
import DiceGame from './DiceGame/DiceGame';
import MouseEvent from './MouseEvent/MouseEvent';
import MountainsCottage from './MountainsCottage/MountainsCottage';
import TypingTeacher from './TypingTeacher/TypingTeacher';
import Survey from './Survey/Survey';
import WeatherReport from './WeatherReport/WeatherReport';
import Clicker from './Clicker/Clicker';
import Gallery2 from './Gallery2/Gallery2';
import './App.css';
import { useState } from 'react';

function App() {
   const [isHeaderChecked, setIsHeaderChecked] = useState(true);
   const [isTutorialChecked, setIsTutorialChecked] = useState(true);
   const [isGalleryChecked, setIsGalleryChecked] = useState(false);
   const [isFormChecked, setIsFormChecked] = useState(false);
   const [isGameChecked, setIsGameChecked] = useState(false);
   const [isDiceGameChecked, setIsDiceGameChecked] = useState(false);
   const [isMouseEventChecked, setIsMouseEventChecked] = useState(false)
   const [isMountainsCottageChecked, setIsMountainsCottageChecked] = useState(false)
   const [isTypingTeacherChecked, setIsTypingTeacherChecked] = useState(false);
   const [isSurveyChecked, setIsSurveyChecked] = useState(false);
   const [isWeatherReportChecked, setIsWeatherReportChecked] = useState(false);
   const [isClickerChecked, setIsClickerChecked] = useState(false);
   const [isGallery2Checked, setIsGallery2Checked] = useState(false);

   const handleTutorial = () => {
      setIsTutorialChecked(!isTutorialChecked);
    };
   
   const handleHeader = () => {
      setIsHeaderChecked(!isHeaderChecked);
    };
   
   const handleGallery = () => {
      setIsGalleryChecked(!isGalleryChecked);
    };
   
   const handleForm = () => {
      setIsFormChecked(!isFormChecked);
    };

    const handleGame = () => {
      setIsGameChecked(!isGameChecked);
    };

    const handleDiceGame = () => {
      setIsDiceGameChecked(!isDiceGameChecked);
    };

    const handleMouseEvent = () => {
      setIsMouseEventChecked(!isMouseEventChecked);
    };

    const handleMountainsCottage = () =>{
      setIsMountainsCottageChecked(!isMountainsCottageChecked);
    }

    const handleTypingTeacher = () =>{
      setIsTypingTeacherChecked(!isTypingTeacherChecked);
    }

    const handleSurvey = () =>{
      setIsSurveyChecked(!isSurveyChecked);
    }

    const handleWeatherReport = () =>{
      setIsWeatherReportChecked(!isWeatherReportChecked);
    }

    const handleClicker = () =>{
      setIsClickerChecked(!isClickerChecked);
    }

    const handleGallery2 = () => {
      setIsGallery2Checked(!isGallery2Checked);
    };

  return (
    <div id="container">
      <div>
         {
            isHeaderChecked && <div className="comp" >
                                    <Flower />
                                </div>
         }
       </div>
       <div>
         {
            isTutorialChecked && <div className="comp" >
                                    <Tutor />
                                </div>
         }
       </div>
       <div className="comp" > 
         <p>React Components:</p> 
            <input type="checkbox" value={isHeaderChecked} onChange={handleHeader} checked={isHeaderChecked} /> Header<br />
            <input type="checkbox" value={isTutorialChecked} onChange={handleTutorial} checked={isTutorialChecked} /> Tutorial<br />
            <input type="checkbox" value={isGalleryChecked} onChange={handleGallery} /> Gallery<br />
            <input type="checkbox" value={isFormChecked} onChange={handleForm} /> Form  <br /> 
            <input type="checkbox" value={isGameChecked} onChange={handleGame} /> Game <br />  
            <input type="checkbox" value={isDiceGameChecked} onChange={handleDiceGame} /> Dice Game <br /> 
            <input type='checkbox' value={isMouseEventChecked} onChange={handleMouseEvent} /> Mouse Event <br />
            <input type='checkbox' value={isMountainsCottageChecked} onChange={handleMountainsCottage} /> Mountains Cottage <br />   
            <input type='checkbox' value={isTypingTeacherChecked} onChange={handleTypingTeacher} /> Typing Teacher <br />
            <input type='checkbox' value={isSurveyChecked} onChange={handleSurvey} /> Survey <br />
            <input type='checkbox' value={isWeatherReportChecked} onChange={handleWeatherReport} /> Weather Report <br />
            <input type='checkbox' value={isClickerChecked} onChange={handleClicker} /> Clicker <br />
            <input type="checkbox" value={isGallery2Checked} onChange={handleGallery2} /> Gallery2<br />
      </div>
       {/*
         gdy isGalleryChecked == true  pojawia sie galeria
         stan isGalleryChecked zmienia sie checkboxem
       */}
       <div>
         {
            isGalleryChecked && <div className="comp" >
                                    <Gallery />
                                </div>
         }
       </div>
       <div>
         {
            isFormChecked && <div className="comp" >
                                    <UserForm />
                             </div>
         }
       </div>
       <div>
         {
            isGameChecked && <div className="comp" >
                                    <Ping />
                             </div>
         }
       </div>
       <div>
         {
            isDiceGameChecked && <div className="comp" >
                                    <DiceGame />
                             </div>
         }
       </div>
       <div>
         {
            isMouseEventChecked && <div className="comp" >
                                    <MouseEvent />
                             </div>
         }
       </div>
       <div>
         {
            isMountainsCottageChecked && <div className="comp" >
                                    <MountainsCottage />
                             </div>
         }
       </div>
       <div>
         {
            isTypingTeacherChecked && <div className="comp" >
                                    <TypingTeacher />
                             </div>
         }
       </div>
       <div>
         {
            isSurveyChecked && <div className="comp" >
                                    <Survey />
                             </div>
         }
       </div>
       <div>
         {
            isWeatherReportChecked && <div className="comp" >
                                    <WeatherReport />
                             </div>
         }
       </div>
       <div>
         {
            isClickerChecked && <div className="comp" >
                                    <Clicker />
                             </div>
         }
       </div>
       <div>
         {
            isGallery2Checked && <div className="comp" >
                                    <Gallery2 />
                                </div>
         }
       </div>
      
    </div>
  );
}

export default App;
